<template>
  <div class="col-12 contenidoSlider"  v-if="banSettingsTA" >
  <div>
    <video controls autoplay loop muted>
      <source :src="videoUrl" type="video/mp4" />
      {{ $t('language.posadasCorporate.TABookingEngine.textVideoFail') }}
    </video>
  </div>

<!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution"> <i class="demo-icon icon-warning-fill Fw-bolder"></i> {{ $t('language.posadasCorporate.modales.expiredSession.title') }}</b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.modales.expiredSession.body') }}
        </p>
      </template>
      <template slot="footer">

        <button type="button" class="button btn-primary" @click="closeExpiredModal"
                aria-label="Close modal">
          {{ $t('language.posadasCorporate.modales.expiredSession.button') }}
        </button>

      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->
  </div>


</template>

<script>

  import { VueAgile } from '../../customComponents/vue-agile';
  import SecureLS from 'secure-ls'
  import Loader from '../loader/Loader';
  import Modal from '../addons/Modal.vue';
  import * as GlobalFunctions from '../../utils/GlobalFunctions';
  import * as GlobalServices from '../../utils/GlobalServices';
 
export default {
  components: {
    agile: VueAgile,
    Loader,
    Modal
  },
  name: 'video',
  data:() => {
    return {
      videoUrl: require('@/assets/img/videoTABooking/Posadas_Hoteles_V7.mp4'), // Importa el video de assets
      banSettingsTA: false,
      contActualizaComponente: 0,
      ls: new SecureLS({ encodingType: "aes" }),
      isExpiredModalVisible: false,
    }
  },
  computed: {
  },
  methods: {
    closeExpiredModal() {
  this.isExpiredModalVisible = false
             var ls = new SecureLS({encodingType: 'aes'});
             GlobalFunctions.localStorageClean();
                this.$router.push({ name: "Login" });
    },
  },
  created(){
    var ls = new SecureLS({ encodingType: "aes" });
    var readingProfile = ls.get("Profile");


    var ProfileType = "";
    if(readingProfile){
      ProfileType = readingProfile.data.profileType;
    }

    if(ProfileType == 'TA'){
        GlobalServices._searchConfigTA(this.ls.get("Token").data).then(response => {
          if (response.status == 200) {
                response.data.response.forEach(item => {
                var test=item.title;
                if(test == "VIDEO_HOME" && item.flag== "TRUE"){
                  this.banSettingsTA = true;
                  }
                });
              }
          })
          .catch(error => {
            console.log("error: "+error)
          });
      }else{
        console.log("componente bloqueado porque es other user");
        this.banSettingsTA = false;
      }

  },
  sesionClose(){
           this.isExpiredModalVisible = true

  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/scss/config.scss';
  .bodyPromo {
    padding: 51px 20px;
  }
  
  video{
  width: 100%;
  //height: 360;
  }
</style>